import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  students: [],
  teachers: [],
  notebooks: {},
  materials: [],
  statisticsAll: {},
};

const additionalStatisticsSlice = createSlice({
  name: 'additionalStatistics',
  initialState,
  reducers: {
    setStudentsState: (state, action) => {
      state.students = action.payload;
    },
    addStudentState: (state, action) => {
      state.students.push(action.payload);
    },
    setTeachersState: (state, action) => {
      state.teachers = action.payload;
    },
    addTeacherState: (state, action) => {
      state.teachers.push(action.payload);
    },
    setNotebooksState: (state, action) => {
      state.notebooks = action.payload;
    },
    addNotebookState: (state, action) => {
      state.notebooks.push(action.payload);
    },
    setMaterialsState: (state, action) => {
      state.materials = action.payload;
    },
    addMaterialState: (state, action) => {
      state.materials.push(action.payload);
    },
    setStatisticsAllState: (state, action) => {
      state.statisticsAll = action.payload;
    },
    addStatisticsAllState: (state, action) => {
      state.statisticsAll.push(action.payload);
    },
  },
});

export const {
  setStudentsState,
  addStudentState,
  setTeachersState,
  addTeacherState,
  setNotebooksState,
  addNotebookState,
  setMaterialsState,
  addMaterialState,
  setStatisticsAllState,
  addStatisticsAllState,
} = additionalStatisticsSlice.actions;

export const selectStudents = state => state.additionalStatistics.students;
export const selectTeachers = state => state.additionalStatistics.teachers;
export const selectNotebooks = state => state.additionalStatistics.notebooks;
export const selectMaterials = state => state.additionalStatistics.materials;
export const selectStatisticsAll = state => state.additionalStatistics.statisticsAll;

export default additionalStatisticsSlice.reducer;
